import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { PredictionRotaWeek } from '../classes/models/PredictionRotaWeek';

/**
 * This service handles converting HTML data to PDF.
 */
@Injectable({
  providedIn: 'root'
})
export class PdfService {

  /**
   * Converts weekly rota HTML data to PDF.
   * @param weeks a list of weeks containing rota data.
   */
  getPDF(weeks: PredictionRotaWeek[]): Promise<jsPDF> {
    const doc = new jsPDF('p', 'mm');
    const fileWidth = 208;
    const images = [];

    weeks.forEach(week => {
      const image = html2canvas(document.getElementById('rota-week-' + week.id)).then(canvas => {
        const fileHeight = canvas.height * fileWidth / canvas.width;
        const FILEURI = canvas.toDataURL('image/png');
        return new ImageProperties(FILEURI, fileHeight);
      });
      images.push(image);
    });

    let pageCount = 1;
    return Promise.all(images).then(promises => {
      promises.forEach(promise => {
        doc.addImage(promise.fileUri, 'PNG', 5, 10, fileWidth - 10, promise.fileHeight);
        if (pageCount < images.length) {
          doc.addPage();
        }
        pageCount++;
      });
      return doc;
    });
  }
}

class ImageProperties {
  fileUri: string;
  fileHeight: number;

  constructor(fileUri: string, fileHeight: number) {
    this.fileUri = fileUri;
    this.fileHeight = fileHeight;
  }
}
